<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('attendanceJustificationsCatalog.breadcrumb' | translate)]"
                      [active_item]="'attendanceJustificationsCatalog.detail.breadcrumb' | translate"></app-breadcrumb>
    </div>

    <div class="attendance-justification-workspace"
         [class.attendance-justification-workspace--loading]="isLoading">
      <mat-card class="attendance-justification-panel">
        <div class="attendance-justification-panel__header">
          <div class="attendance-justification-panel__heading">
            @if (isViewMode) {
              <div class="attendance-justification-panel__hero-icon"><mat-icon>schedule</mat-icon></div>
            }
            <div class="attendance-justification-panel__heading-copy">
              @if (isViewMode) {
                <span class="attendance-justification-panel__category">{{ 'attendanceJustificationsCatalog.detail.category' | translate }}</span>
              } @else {
                <span class="attendance-justification-panel__eyebrow">{{ 'attendanceJustificationsCatalog.breadcrumb' | translate }}</span>
              }
              <h3>{{ detailTitle }}</h3>
              <p>{{ detailDescription }}</p>
            </div>
          </div>
          <div class="attendance-justification-panel__actions">
            @if (isViewMode && selectedAttendanceJustification; as justification) {
              <button mat-stroked-button
                      type="button"
                      class="btn-tone-accent"
                      *appCanAccess="updateAccess"
                      [disabled]="justification.status !== 'submitted'"
                      (click)="approveSelected()">
                <mat-icon>task_alt</mat-icon>
                {{ 'attendanceJustificationsCatalog.actions.approve' | translate }}
              </button>
              <button mat-stroked-button
                      type="button"
                      class="btn-tone-warn"
                      *appCanAccess="updateAccess"
                      [disabled]="justification.status !== 'submitted'"
                      (click)="rejectSelected()">
                <mat-icon>close</mat-icon>
                {{ 'attendanceJustificationsCatalog.actions.reject' | translate }}
              </button>
              <button mat-stroked-button
                      type="button"
                      class="btn-tone-neutral"
                      *appCanAccess="updateAccess"
                      [disabled]="!(justification.status === 'submitted' || justification.status === 'approved')"
                      (click)="cancelSelected()">
                <mat-icon>block</mat-icon>
                {{ 'attendanceJustificationsCatalog.actions.cancel' | translate }}
              </button>
              <button mat-stroked-button
                      type="button"
                      class="btn-tone-accent"
                      *appCanAccess="updateAccess"
                      [disabled]="justification.status !== 'submitted'"
                      (click)="startEdit()">
                <mat-icon>edit</mat-icon>
                {{ 'common.update' | translate }}
              </button>
              <button mat-stroked-button
                      type="button"
                      class="btn-tone-warn"
                      *appCanAccess="deleteAccess"
                      [disabled]="justification.status === 'approved'"
                      (click)="deleteSelected()">
                <mat-icon>delete_outline</mat-icon>
                {{ 'common.delete' | translate }}
              </button>
            }
            @if (isCreateMode || isEditMode) {
              <button mat-flat-button
                      type="button"
                      color="primary"
                      [disabled]="isSaving || !canSave"
                      (click)="save()">
                <mat-icon>save</mat-icon>
                {{ isCreateMode ? ('common.create' | translate) : ('common.saveChanges' | translate) }}
              </button>
              <button mat-stroked-button
                      type="button"
                      class="btn-tone-neutral"
                      (click)="cancelEdit()">
                <mat-icon>close</mat-icon>
                {{ 'common.cancel' | translate }}
              </button>
            }
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="goBackToList()">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.back' | translate }}
            </button>
          </div>
        </div>

        <div class="attendance-justification-panel__body">
          @if (isCreateMode || isEditMode) {
            <div class="attendance-justification-editor">
              <div class="card attendance-justification-editor__card mb-0">
                <div class="card-body">
                  <div class="attendance-justification-section-heading">
                    <h4>{{ 'attendanceJustificationsCatalog.sections.general' | translate }}</h4>
                    <p>{{ 'attendanceJustificationsCatalog.sections.generalDescription' | translate }}</p>
                  </div>

                  <div class="row g-3">
                    <div class="col-12 col-xl-8">
                      <mat-form-field subscriptSizing="dynamic" appearance="outline" class="w-100">
                        <mat-label>{{ 'attendanceJustificationsCatalog.fields.employee' | translate }}</mat-label>
                        <input matInput
                               #employeeTrigger="matAutocompleteTrigger"
                               [ngModel]="employeeSearchText"
                               (ngModelChange)="onEmployeeSearchInput($event)"
                               [ngModelOptions]="{ standalone: true }"
                               [matAutocomplete]="employeeAutocomplete"
                               [placeholder]="'attendanceJustificationsCatalog.filters.employeePlaceholder' | translate"
                               autocomplete="off"
                               (focus)="employeeTrigger.openPanel()"
                               (click)="employeeTrigger.openPanel()" />
                        <button mat-icon-button
                                matSuffix
                                type="button"
                                tabindex="-1"
                                (click)="employeeTrigger.openPanel()">
                          <mat-icon>search</mat-icon>
                        </button>
                        <mat-autocomplete #employeeAutocomplete="matAutocomplete"
                                          [displayWith]="displayEmployeeOption"
                                          (optionSelected)="onEmployeeSelected($event)">
                          @for (employee of filteredEmployees; track employee.employeeId) {
                            <mat-option [value]="employee">
                              {{ formatEmployeeOptionLabel(employee) }}
                            </mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>

                    <div class="col-12 col-xl-4">
                      <div class="attendance-justification-info-field">
                        <span>{{ 'attendanceJustificationsCatalog.fields.orgUnit' | translate }}</span>
                        <strong>{{ selectedEmployeeOrgUnitLabel }}</strong>
                      </div>
                    </div>

                    <div class="col-12 col-xl-6">
                      <mat-form-field subscriptSizing="dynamic" appearance="outline" class="w-100">
                        <mat-label>{{ 'attendanceJustificationsCatalog.fields.type' | translate }}</mat-label>
                        <mat-select [(ngModel)]="form.attendanceJustificationTypeId"
                                    [ngModelOptions]="{ standalone: true }"
                                    (selectionChange)="onTypeChanged()">
                          @for (type of justificationTypes; track type.attendanceJustificationTypeId) {
                            <mat-option [value]="type.attendanceJustificationTypeId">{{ type.label }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="col-12 col-md-6 col-xl-3">
                      <mat-form-field subscriptSizing="dynamic" appearance="outline" class="w-100">
                        <mat-label>{{ 'attendanceJustificationsCatalog.fields.scope' | translate }}</mat-label>
                        <mat-select [(ngModel)]="form.scope"
                                    [ngModelOptions]="{ standalone: true }"
                                    [disabled]="isAbsenceFlow">
                          @for (scope of availableScopeOptions; track scope) {
                            <mat-option [value]="scope">{{ ('attendanceJustificationsCatalog.scopeOptions.' + scope) | translate }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="col-12 col-md-6 col-xl-3">
                      <app-date-time-picker-field class="w-100"
                                                  [label]="'attendanceJustificationsCatalog.fields.workDate' | translate"
                                                  [value]="form.workDate"
                                                  mode="date"
                                                  (valueChange)="form.workDate = $event">
                      </app-date-time-picker-field>
                    </div>

                    @if (showMinutesField) {
                      <div class="col-12 col-md-6">
                        <mat-form-field subscriptSizing="dynamic" appearance="outline" class="w-100">
                          <mat-label>{{ 'attendanceJustificationsCatalog.fields.minutes' | translate }}</mat-label>
                          <input matInput
                                 type="number"
                                 min="1"
                                 step="1"
                                 [(ngModel)]="form.minutesText"
                                 [ngModelOptions]="{ standalone: true }" />
                        </mat-form-field>
                      </div>
                    }

                    <div class="col-12">
                      <mat-form-field subscriptSizing="dynamic" appearance="outline" class="w-100">
                        <mat-label>{{ 'attendanceJustificationsCatalog.fields.comment' | translate }}</mat-label>
                        <textarea matInput
                                  rows="4"
                                  [(ngModel)]="form.comment"
                                  [ngModelOptions]="{ standalone: true }"
                                  [placeholder]="'attendanceJustificationsCatalog.fields.commentPlaceholder' | translate"></textarea>
                      </mat-form-field>
                    </div>

                    <div class="col-12">
                      <div class="attendance-justification-upload">
                        <div class="attendance-justification-upload__header">
                          <div>
                            <span class="attendance-justification-upload__label">{{ 'attendanceJustificationsCatalog.fields.attachments' | translate }}</span>
                            <p>{{ 'attendanceJustificationsCatalog.fields.attachmentsHint' | translate }}</p>
                          </div>
                          <label class="attendance-justification-upload__button"
                                 [class.attendance-justification-upload__button--disabled]="isUploadingAttachments">
                            <input type="file"
                                   accept="image/*"
                                   multiple
                                   [disabled]="isUploadingAttachments"
                                   (change)="onAttachmentFilesSelected($event)" />
                            <mat-icon>upload</mat-icon>
                            <span>{{ 'attendanceJustificationsCatalog.actions.selectAttachments' | translate }}</span>
                          </label>
                        </div>

                        @if (selectedAttachmentFiles.length) {
                          <div class="attendance-justification-upload__pending">
                            @for (file of selectedAttachmentFiles; track file.name + '-' + file.size) {
                              <span class="attendance-justification-attachment-chip">
                                <mat-icon>image</mat-icon>
                                {{ file.name }}
                              </span>
                            }
                          </div>
                        }

                        @if (attachmentsPreview.length) {
                          <div class="attendance-justification-attachments-grid row g-3">
                            @for (attachment of attachmentsPreview; track attachment.url; let attachmentIndex = $index) {
                              <div class="col-12 col-sm-6 col-lg-4">
                                <div class="attendance-justification-attachment-card">
                                  <div class="attendance-justification-attachment-card__preview"
                                       role="button"
                                       tabindex="0"
                                       (click)="viewAttachment(attachmentIndex)"
                                       (keydown.enter)="viewAttachment(attachmentIndex)">
                                    @if (getAttachmentPreviewUrl(attachmentIndex); as previewUrl) {
                                      <img [src]="previewUrl"
                                           [alt]="attachment.name || ('attendanceJustificationsCatalog.fields.attachments' | translate)" />
                                    } @else {
                                      <mat-icon>image</mat-icon>
                                    }
                                  </div>
                                  <div class="attendance-justification-attachment-card__meta">
                                    <strong>{{ attachment.name || ('attendanceJustificationsCatalog.labels.attachment' | translate) }}</strong>
                                    <span>{{ attachment.contentType || 'image/*' }}</span>
                                  </div>
                                  @if (isCreateMode || isEditMode) {
                                    <button mat-icon-button
                                            type="button"
                                            class="btn-tone-danger"
                                            (click)="removeAttachmentAt(attachmentIndex)">
                                      <mat-icon>close</mat-icon>
                                    </button>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        } @else {
                          <span class="attendance-justification-empty-text">{{ 'attendanceJustificationsCatalog.labels.noAttachments' | translate }}</span>
                        }
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div class="card attendance-justification-editor__card mb-0">
                <div class="card-body">
                  <div class="attendance-justification-section-heading">
                    <h4>{{ 'attendanceJustificationsCatalog.sections.typeConfiguration' | translate }}</h4>
                    <p>{{ 'attendanceJustificationsCatalog.sections.typeConfigurationDescription' | translate }}</p>
                  </div>

                  @if (selectedTypeConfig; as typeConfig) {
                    <div class="row g-3">
                      <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.scope' | translate }}</span><strong>{{ ('attendanceJustificationsCatalog.scopeAllowedOptions.' + typeConfig.scopeAllowed) | translate }}</strong></div></div>
                      <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.payEffect' | translate }}</span><strong>{{ ('attendanceJustificationsCatalog.payEffectOptions.' + typeConfig.payEffect) | translate }}</strong></div></div>
                      <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.attendanceEffect' | translate }}</span><strong>{{ ('attendanceJustificationsCatalog.attendanceEffectOptions.' + typeConfig.attendanceEffect) | translate }}</strong></div></div>
                      <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.requiresApproval' | translate }}</span><strong>{{ typeConfig.requiresApproval ? ('common.yes' | translate) : ('common.no' | translate) }}</strong></div></div>
                      <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.requireComment' | translate }}</span><strong>{{ typeConfig.requireComment ? ('common.yes' | translate) : ('common.no' | translate) }}</strong></div></div>
                      <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.requireAttachment' | translate }}</span><strong>{{ typeConfig.requireAttachment ? ('common.yes' | translate) : ('common.no' | translate) }}</strong></div></div>
                    </div>
                  } @else {
                    <div class="attendance-justification-empty">
                      <mat-icon>fact_check</mat-icon>
                      <p>{{ 'attendanceJustificationsCatalog.labels.noTypeSelected' | translate }}</p>
                    </div>
                  }
                </div>
              </div>
            </div>
          } @else if (selectedAttendanceJustification; as justification) {
            <div class="attendance-justification-detail">
              <div class="card attendance-justification-detail__summary mb-0">
                <div class="card-body">
                  <div class="row g-3">
                    <div class="col-md-6 col-xl-3"><div class="attendance-justification-metric-card metric-employee"><div class="attendance-justification-metric-card__icon"><mat-icon>badge</mat-icon></div><div><span>{{ 'attendanceJustificationsCatalog.fields.employeeNumber' | translate }}</span><strong>{{ justification.employeeNumber }}</strong></div></div></div>
                    <div class="col-md-6 col-xl-3"><div class="attendance-justification-metric-card metric-date"><div class="attendance-justification-metric-card__icon"><mat-icon>calendar_month</mat-icon></div><div><span>{{ 'attendanceJustificationsCatalog.fields.workDate' | translate }}</span><strong>{{ justification.workDateLabel }}</strong><small>{{ workDayLabel }}</small></div></div></div>
                    <div class="col-md-6 col-xl-3"><div class="attendance-justification-metric-card metric-status"><div class="attendance-justification-metric-card__icon"><mat-icon>check_circle</mat-icon></div><div><span>{{ 'attendanceJustificationsCatalog.fields.status' | translate }}</span><strong class="metric-pill metric-pill--status">{{ justification.statusLabel }}</strong></div></div></div>
                    <div class="col-md-6 col-xl-3"><div class="attendance-justification-metric-card metric-pay"><div class="attendance-justification-metric-card__icon"><mat-icon>paid</mat-icon></div><div><span>{{ 'attendanceJustificationsCatalog.fields.payEffect' | translate }}</span><strong class="metric-pill">{{ justification.payEffectLabel }}</strong></div></div></div>
                  </div>
                </div>
              </div>

              <div class="card attendance-justification-detail__section-card mb-0">
                <div class="card-body">
                  <div class="attendance-justification-section-heading attendance-justification-section-heading--icon">
                    <div class="attendance-justification-section-heading__icon"><mat-icon>description</mat-icon></div>
                    <div><h4>{{ 'attendanceJustificationsCatalog.sections.general' | translate }}</h4>
                    <p>{{ 'attendanceJustificationsCatalog.sections.generalDescription' | translate }}</p></div>
                  </div>
                  <div class="row g-0 attendance-justification-general-grid">
                    <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.employee' | translate }}</span><strong>{{ justification.employeeLabel || '-' }}</strong></div></div>
                    <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.company' | translate }}</span><strong>{{ justification.companyName || '-' }}</strong></div></div>
                    <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.orgUnit' | translate }}</span><strong>{{ justification.orgUnitName || '-' }}</strong></div></div>
                    <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.type' | translate }}</span><strong>{{ justification.typeLabel }}</strong></div></div>
                    <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.scope' | translate }}</span><strong>{{ justification.scopeLabel }}</strong></div></div>
                    <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.minutes' | translate }}</span><strong>{{ justification.minutesLabel }}</strong></div></div>
                    <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.attendanceEffect' | translate }}</span><strong>{{ justification.attendanceEffectLabel }}</strong></div></div>
                    <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.administrativeStatus' | translate }}</span><strong>{{ justification.activeLabel }}</strong></div></div>
                    <div class="col-md-6 col-xl-4"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.createdAt' | translate }}</span><strong>{{ justification.createdAtLabel }}</strong></div></div>
                  </div>
                </div>
              </div>

              <div class="card attendance-justification-detail__section-card mb-0">
                <div class="card-body">
                  <div class="attendance-justification-section-heading attendance-justification-section-heading--icon">
                    <div class="attendance-justification-section-heading__icon"><mat-icon>forum</mat-icon></div>
                    <div><h4>{{ 'attendanceJustificationsCatalog.sections.request' | translate }}</h4>
                    <p>{{ 'attendanceJustificationsCatalog.sections.requestDescription' | translate }}</p></div>
                  </div>
                  <div class="row g-2 attendance-justification-request-grid">
                    <div class="col-12"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.comment' | translate }}</span><strong>{{ justification.comment || '-' }}</strong></div></div>
                    <div class="col-md-6"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.submittedBy' | translate }}</span><strong>{{ justification.submittedByName || justification.submittedByUid || '-' }}</strong></div></div>
                    <div class="col-md-6"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.submittedAt' | translate }}</span><strong>{{ justification.submittedAtLabel }}</strong></div></div>
                  </div>
                </div>
              </div>

              <div class="card attendance-justification-detail__section-card mb-0">
                <div class="card-body">
                  <div class="attendance-justification-section-heading attendance-justification-section-heading--icon">
                    <div class="attendance-justification-section-heading__icon"><mat-icon>settings</mat-icon></div>
                    <div><h4>{{ 'attendanceJustificationsCatalog.sections.resolution' | translate }}</h4>
                    <p>{{ 'attendanceJustificationsCatalog.sections.resolutionDescription' | translate }}</p></div>
                  </div>
                  <div class="row g-2 attendance-justification-resolution-grid">
                    <div class="col-md-6 col-xl-3"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.resolutionType' | translate }}</span><strong>{{ justification.resolutionTypeLabel }}</strong></div></div>
                    <div class="col-md-6 col-xl-3"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.resolvedBy' | translate }}</span><strong>{{ justification.resolvedByName || justification.resolvedByUid || '-' }}</strong></div></div>
                    <div class="col-md-6 col-xl-3"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.resolvedAt' | translate }}</span><strong>{{ justification.resolvedAtLabel }}</strong></div></div>
                    <div class="col-md-6 col-xl-3"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.updatedAt' | translate }}</span><strong>{{ justification.updatedAtLabel }}</strong></div></div>
                    <div class="col-12"><div class="attendance-justification-soft-card"><span>{{ 'attendanceJustificationsCatalog.fields.resolutionComment' | translate }}</span><strong>{{ justification.resolutionComment || '-' }}</strong></div></div>
                  </div>
                </div>
              </div>

              <div class="card attendance-justification-detail__section-card mb-0">
                <div class="card-body">
                  <div class="attendance-justification-section-heading attendance-justification-section-heading--icon">
                    <div class="attendance-justification-section-heading__icon"><mat-icon>attach_file</mat-icon></div>
                    <div><h4>{{ 'attendanceJustificationsCatalog.sections.attachments' | translate }}</h4>
                    <p>{{ 'attendanceJustificationsCatalog.sections.attachmentsDescription' | translate }}</p></div>
                  </div>
                  @if (attachmentsPreview.length) {
                    <div class="attendance-justification-view-attachments">
                      @for (attachment of attachmentsPreview; track $index; let attachmentIndex = $index) {
                        @if (attachment.contentType?.startsWith('image/')) {
                          <article class="attendance-justification-inline-image">
                            <button type="button"
                                    class="attendance-justification-inline-image__preview"
                                    [disabled]="!getAttachmentPreviewUrl(attachmentIndex) || openingAttachmentIndexes.has(attachmentIndex)"
                                    (click)="viewAttachment(attachmentIndex)">
                              @if (getAttachmentPreviewUrl(attachmentIndex); as previewUrl) {
                                <img [src]="previewUrl"
                                     [alt]="attachment.name || ('attendanceJustificationsCatalog.labels.attachment' | translate)" />
                                <span class="attendance-justification-inline-image__expand">
                                  <mat-icon>fullscreen</mat-icon>
                                </span>
                              } @else {
                                <span class="attendance-justification-inline-image__loading">
                                  <mat-icon>image</mat-icon>
                                  <small>{{ 'common.loading' | translate }}</small>
                                </span>
                              }
                            </button>
                            <div class="attendance-justification-inline-image__meta">
                              <span class="attendance-justification-view-attachment__icon"><mat-icon>image</mat-icon></span>
                              <span class="attendance-justification-view-attachment__content">
                                <strong>{{ attachment.name || ('attendanceJustificationsCatalog.labels.attachment' | translate) + ' ' + (attachmentIndex + 1) }}</strong>
                                <small>{{ attachment.contentType }}</small>
                              </span>
                              <button mat-icon-button type="button" (click)="viewAttachment(attachmentIndex)" [attr.aria-label]="'attendanceJustificationsCatalog.actions.openAttachment' | translate">
                                <mat-icon>open_in_new</mat-icon>
                              </button>
                            </div>
                          </article>
                        } @else {
                          <button type="button"
                                  class="attendance-justification-view-attachment"
                                  [disabled]="openingAttachmentIndexes.has(attachmentIndex)"
                                  (click)="viewAttachment(attachmentIndex)">
                            <span class="attendance-justification-view-attachment__icon"><mat-icon>attach_file</mat-icon></span>
                            <span class="attendance-justification-view-attachment__content">
                              <strong>{{ attachment.name || ('attendanceJustificationsCatalog.labels.attachment' | translate) + ' ' + (attachmentIndex + 1) }}</strong>
                              <small>{{ attachment.contentType || ('attendanceJustificationsCatalog.labels.attachmentFile' | translate) }}</small>
                            </span>
                            <mat-icon class="attendance-justification-view-attachment__action">
                              {{ openingAttachmentIndexes.has(attachmentIndex) ? 'hourglass_top' : 'open_in_new' }}
                            </mat-icon>
                          </button>
                        }
                      }
                    </div>
                  } @else {
                    <div class="attendance-justification-no-attachments">
                      <mat-icon>description</mat-icon>
                      <strong>{{ 'attendanceJustificationsCatalog.labels.noAttachments' | translate }}</strong>
                      <span>{{ 'attendanceJustificationsCatalog.labels.noAttachmentsDescription' | translate }}</span>
                    </div>
                  }
                </div>
              </div>

              <div class="card attendance-justification-detail__section-card mb-0">
                <div class="card-body">
                  <div class="attendance-justification-section-heading attendance-justification-section-heading--icon attendance-justification-history-heading">
                    <div class="attendance-justification-section-heading__icon"><mat-icon>list</mat-icon></div>
                    <div><h4>{{ 'attendanceJustificationsCatalog.sections.history' | translate }}</h4>
                    <p>{{ 'attendanceJustificationsCatalog.sections.historyDescription' | translate }}</p></div>
                    <span class="attendance-justification-history-count">{{ 'attendanceJustificationsCatalog.labels.historyCount' | translate:{ count: justification.history.length } }}</span>
                  </div>
                  @if (justification.history.length) {
                    <div class="attendance-justification-history-table">
                      <div class="attendance-justification-history-row attendance-justification-history-row--header">
                        <span>{{ 'attendanceJustificationsCatalog.fields.dateTime' | translate }}</span>
                        <span>{{ 'attendanceJustificationsCatalog.fields.event' | translate }}</span>
                        <span>{{ 'attendanceJustificationsCatalog.fields.user' | translate }}</span>
                        <span>{{ 'attendanceJustificationsCatalog.fields.description' | translate }}</span>
                      </div>
                      @for (item of justification.history; track $index) {
                        <div class="attendance-justification-history-row">
                          <span>{{ item.at ? (item.at | date:'short') : '-' }}</span>
                          <strong><i [class.history-dot--approved]="item.action === 'approved'" class="history-dot"></i>{{ ('attendanceJustificationsCatalog.historyActions.' + item.action) | translate }}</strong>
                          <span>{{ item.byName || item.byUid || '-' }}</span>
                          <span>{{ item.comment || '-' }}</span>
                        </div>
                      }
                    </div>
                  } @else {
                    <span class="attendance-justification-empty-text">{{ 'attendanceJustificationsCatalog.labels.noHistory' | translate }}</span>
                  }
                </div>
              </div>
            </div>
          } @else {
            <div class="attendance-justification-empty">
              <mat-icon>fact_check</mat-icon>
              <h4>{{ 'attendanceJustificationsCatalog.emptyEditorTitle' | translate }}</h4>
              <p>{{ 'attendanceJustificationsCatalog.emptyEditorDescription' | translate }}</p>
            </div>
          }
        </div>
      </mat-card>

      @if (isLoading) {
        <app-loading-state class="attendance-justification-loading"
                           [message]="'attendanceJustificationsCatalog.loading' | translate" />
      }
    </div>
  </div>
</section>
